import { defineMessages } from 'react-intl';

export const i18n: {
	positionFilterTeamLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterTeamPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterTeamLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	positionFilterTeamLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	positionFilterTeamLabel: {
		id: 'search-page.filters.names.positionTeam',
		defaultMessage: 'Team',
		description:
			'The text is shown as the filter name label in the search filter bar for talent positions, allowing users to narrow results by team.',
	},
	positionFilterTeamPlaceholder: {
		id: 'search-page.talent.filter.position-team.content.placeholder',
		defaultMessage: 'Find teams',
		description: 'Placeholder for team filter search input',
	},
	positionFilterTeamLabelSelected: {
		id: 'search-page.talent.filter.position-team.content.selected',
		defaultMessage: 'Selected',
		description:
			'The text is shown as a section heading in the talent position team filter drop-down, grouping teams the user has already selected.',
	},
	positionFilterTeamLabelUnselected: {
		id: 'search-page.talent.filter.position-team.content.unselected',
		defaultMessage: 'Suggested',
		description:
			'The text is shown as a section heading in the talent position team filter drop-down, grouping recommended teams not yet selected.',
	},
});
